import ai from "./client-hints-parser.js";
import oi from "./user-agent-parser.js";
import { Browsers as gi, OperatingSystems as Y } from "./device-constants.js";
class ui {
  constructor() {
    const t = navigator.userAgentData ? ai : oi;
    (this.Sg = new t()),
      (this.userAgent = navigator.userAgent),
      (this.browser = this.Sg.ef()),
      (this.version = this.Sg.sf()),
      (this.OS = null),
      this.Da().then((t) => (this.OS = t));
    const i = navigator;
    (this.language = (
      i.userLanguage ||
      i.language ||
      i.browserLanguage ||
      i.systemLanguage ||
      ""
    ).toLowerCase()),
      (this.Qo = ui.vg(this.userAgent));
  }
  IE() {
    return this.browser === gi.Bg;
  }
  Ca() {
    return this.OS || null;
  }
  Da() {
    return this.OS
      ? Promise.resolve(this.OS)
      : this.Sg.Da(ui.kg).then((t) => ((this.OS = t), t));
  }
  static vg(t) {
    t = t.toLowerCase();
    const i = [
      "googlebot",
      "bingbot",
      "slurp",
      "duckduckbot",
      "baiduspider",
      "yandex",
      "facebookexternalhit",
      "sogou",
      "ia_archiver",
      "https://github.com/prerender/prerender",
      "aolbuild",
      "bingpreview",
      "msnbot",
      "adsbot",
      "mediapartners-google",
      "teoma",
      "taiko",
    ];
    for (let n = 0; n < i.length; n++) if (-1 !== t.indexOf(i[n])) return !0;
    return !1;
  }
}
ui.kg = [
  { string: navigator.platform, nf: "Win", identity: Y.Og },
  { string: navigator.platform, nf: "Mac", identity: Y.Pg },
  { string: navigator.platform, nf: "BlackBerry", identity: "BlackBerry" },
  { string: navigator.platform, nf: "FreeBSD", identity: "FreeBSD" },
  { string: navigator.platform, nf: "OpenBSD", identity: "OpenBSD" },
  { string: navigator.platform, nf: "Nintendo", identity: "Nintendo" },
  { string: navigator.platform, nf: "SunOS", identity: "SunOS" },
  { string: navigator.platform, nf: "PlayStation", identity: "PlayStation" },
  { string: navigator.platform, nf: "X11", identity: "X11" },
  {
    string: navigator.userAgent,
    nf: ["iPhone", "iPad", "iPod"],
    identity: Y.io,
  },
  { string: navigator.platform, nf: "Pike v", identity: Y.io },
  { string: navigator.userAgent, nf: ["Web0S"], identity: "WebOS" },
  {
    string: navigator.platform,
    nf: ["Linux armv7l", "Android"],
    identity: Y.xg,
  },
  { string: navigator.userAgent, nf: ["Android"], identity: Y.xg },
  { string: navigator.platform, nf: "Linux", identity: "Linux" },
];
const X = new ui();
export { X as default, ui as BrowserDetector };
